import { Pagination } from 'components'
import React, { useState } from 'react'
import UserActivity from './components/UserActivity'
import { useActivity, useUser } from 'hooks';
// import AttendanceTemplate from './components/AttendanceTemplate';

export default function Dashboard() {

    const { defaultProject } = useUser();
    const [currentPage, setCurrentPage] = useState(1);
    const [isFetch, setIsFetch] = useState(1);

    const { fetchData } = useActivity();

    const { data } = fetchData(defaultProject?.id, currentPage, isFetch);
    console.log("🚀 ~ Dashboard ~ data:", data)

    return (
        <div className="grid grid-cols-1 mx-auto">
            {data?.data && <UserActivity data={data?.data || []} />}
            {/* <AttendanceTemplate /> */}
            {data?.totalPage > 1 && <div className='mt-4'>
                <Pagination onPageChange={setCurrentPage} totalPages={data?.totalPage || 1} currentPage={currentPage} />
            </div>}
        </div>
    )
}
